import StarsList from './StarsList';

export default StarsList;
